import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-970906d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "general" }
const _hoisted_4 = {
  key: 0,
  class: "modalMunicipios"
}
const _hoisted_5 = { class: "contenedorMunicipios" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Seleccione el Municipio ", -1))
const _hoisted_7 = { class: "contenidoMunicipios" }
const _hoisted_8 = { class: "contenidoMunicipios" }
const _hoisted_9 = { id: "municipios" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "MUNICIPIO"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA")
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { style: {"margin-top":"20px"} }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_15 = { class: "grid" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "empleador"
}, "Empleador", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipoIdentificacion"
}, "Tipo de Documento", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "N" }, "NSS", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "C" }, "CÉDULA", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "P" }, "PASAPORTE", -1))
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "noIdentificacion"
}, "Número de Documento", -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombres"
}, "Nombres", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "primerApellido"
}, "Primer Apellido", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "segundoApellido"
}, "Segundo Apellido", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "sexo"
}, "Sexo", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "M" }, "MASCULINO", -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "F" }, "FEMENINO", -1))
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaNac"
}, "Fecha de Nacimiento", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "edad"
}, "Edad", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "salar"
}, "Salario", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de Contacto")
], -1))
const _hoisted_37 = { class: "grid" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefonor"
}, "Telefono Recidencial", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefonoc"
}, "Telefono Celular", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefonoFlt"
}, "Teléfono Flota", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "contEmerg"
}, "Nombre Contacto de Emergencia", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "parentesco"
}, "Parentesco", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreRazonSocial"
}, "Teléfono contacto Emergencia ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de Contacto")
], -1))
const _hoisted_45 = { class: "grid" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "direccion"
}, "Dirección", -1))
const _hoisted_47 = { class: "grid" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreRazonSocial"
}, "Municipio", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreRazonSocial"
}, "Provincia", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Médicos")
], -1))
const _hoisted_51 = { class: "grid" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tiporh"
}, "Tipo de Sangre", -1))
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<option value=\"rho\" data-v-970906d6>A+</option><option value=\"rho\" data-v-970906d6>A-</option><option value=\"rho\" data-v-970906d6>B+</option><option value=\"rho\" data-v-970906d6>B-</option><option value=\"rho\" data-v-970906d6>AB+</option><option value=\"rho\" data-v-970906d6>AB-</option><option value=\"rho\" data-v-970906d6>O+</option><option value=\"rho\" data-v-970906d6>O-</option>", 8)
const _hoisted_61 = [
  _hoisted_53
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "alergias"
}, "Alergias", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Otros Datos")
], -1))
const _hoisted_64 = { class: "grid" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nacionalidad"
}, "Nacionalidad", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nivelacad"
}, "Nivel Académico", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "statcivil"
}, "Estado Civil", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "solt" }, "SOLTERO", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "cas" }, "CASADO", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "UL" }, "UNION LIBRE", -1))
const _hoisted_71 = [
  _hoisted_68,
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreRazonSocial"
}, "Conyuge", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreRazonSocial"
}, "Cédula conyuge", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreRazonSocial"
}, "Teléfono Conyuge", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreRazonSocial"
}, "Cantidad de Hijos", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "aseguradora"
}, "Aseguradora", -1))
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<option value=\"5\" data-v-970906d6>ARS CMD</option><option value=\"14\" data-v-970906d6>MAPFRE SALUD ARS, S.A.</option><option value=\"8\" data-v-970906d6>FUTURO</option><option value=\"12\" data-v-970906d6>META SALUD</option><option value=\"23\" data-v-970906d6>YUNEN</option><option value=\"17\" data-v-970906d6>RESERVAS</option><option value=\"13\" data-v-970906d6>MONUMENTAL</option><option value=\"4\" data-v-970906d6>ASEMAP</option><option value=\"1\" data-v-970906d6>ARS APS S.A</option><option value=\"21\" data-v-970906d6>SIMAG</option><option value=\"16\" data-v-970906d6>RENACER</option><option value=\"59\" data-v-970906d6>GRUPO MEDICO ASOCIADO</option><option value=\"24\" data-v-970906d6>PRIMERA ARS DE HUMANO</option><option value=\"10\" data-v-970906d6>HUMANO SEGUROS</option><option value=\"22\" data-v-970906d6>UNIVERSAL</option><option value=\"20\" data-v-970906d6>SENASA CONTRIBUTIVO</option><option value=\"61\" data-v-970906d6>SENASA SUBSIDIADO</option><option value=\"18\" data-v-970906d6>SEMMA</option>", 18)
const _hoisted_95 = [
  _hoisted_77
]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "numerod"
}, "Numero de Dependientes", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Laborales")
], -1))
const _hoisted_98 = { class: "grid" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaContrato"
}, "Fecha de Contrato", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "departamento"
}, "Departamento Actual", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "puesto"
}, "Puesto Actual", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "turno"
}, "Turno Actual", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Financieros")
], -1))
const _hoisted_104 = { class: "grid" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "entidad"
}, "Entidad Bancaria", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cbank"
}, "Número de Cuenta Bancaria", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "frecPag"
}, "Frecuencia de Pago", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Mensual", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Quincenal", -1))
const _hoisted_110 = [
  _hoisted_108,
  _hoisted_109
]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_114 = [
  _hoisted_112,
  _hoisted_113
]
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_116 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_117 = [
  _hoisted_115,
  _hoisted_116
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  class: "img",
                  src: 
              'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
            
                }, null, 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (_ctx.showModalMunicipios)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMunicipioMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "search",
                        type: "search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                        class: "form-control",
                        placeholder: "Introduzca el nombre del municipio",
                        onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscar()))
                      }, null, 544), [
                        [_vModelText, _ctx.search]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("table", _hoisted_9, [
                        _hoisted_10,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.municipiosFiltrados, (municipio, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            onClick: ($event: any) => (_ctx.setMunicipio(municipio))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(municipio.municipio), 1),
                            _createElementVNode("td", null, _toDisplayString(municipio.provincia), 1)
                          ], 8, _hoisted_11))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.encabezado), 1),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("select", {
                    id: "empleador",
                    type: "String",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.empleado.rncEmpleador) = $event)),
                    class: "form-select form-select-sm"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.empleadors, (empleador, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: empleador.rnc
                      }, _toDisplayString(empleador.descripcion), 9, _hoisted_17))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.empleado.rncEmpleador]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("select", {
                    id: "tipoIdentificacion",
                    type: "String",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.empleado.tipoIdentificacion) = $event)),
                    class: "form-select form-select-sm"
                  }, _hoisted_22, 512), [
                    [_vModelSelect, _ctx.empleado.tipoIdentificacion]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fixString('noIdentificacion'))),
                    disabled: this.empleado.disabledId,
                    id: "noIdentificacion",
                    type: "String",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.empleado.noIdentificacion) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 40, _hoisted_24), [
                    [_vModelText, _ctx.empleado.noIdentificacion]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_25,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (
                      _ctx.crearnombrecompleto(
                        'nombres',
                        this.empleado.nombres,
                        this.empleado.primerApellido,
                        this.empleado.segundoApellido
                      )
                    )),
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.empleado.nombres) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.nombres]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (
                      _ctx.crearnombrecompleto(
                        'primerApellido',

                        this.empleado.nombres,
                        this.empleado.primerApellido,
                        this.empleado.segundoApellido
                      )
                    )),
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.empleado.primerApellido) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.primerApellido]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_27,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (
                      _ctx.crearnombrecompleto(
                        'segundoApellido',

                        this.empleado.nombres,
                        this.empleado.primerApellido,
                        this.empleado.segundoApellido
                      )
                    )),
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.empleado.segundoApellido) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.segundoApellido]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_28,
                  _withDirectives(_createElementVNode("select", {
                    id: "sexo",
                    type: "String",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.empleado.sexo) = $event)),
                    class: "form-select form-select-sm"
                  }, _hoisted_32, 512), [
                    [_vModelSelect, _ctx.empleado.sexo]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (this.calcularEdad(_ctx.empleado.fechaNac))),
                    id: "fechaNac",
                    type: "date",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.empleado.fechaNac) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.fechaNac]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_34,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "edad",
                    type: "number",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.empleado.edad) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.edad]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("input", {
                    id: "salar",
                    type: "number",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.empleado.salar) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.salar]
                  ])
                ])
              ]),
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", null, [
                  _hoisted_38,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.defTelefono('telefonor'))),
                    id: "telefonor",
                    type: "String",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.empleado.telefonor) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.telefonor]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.defTelefono('telefonoc'))),
                    id: "telefonoc",
                    type: "String",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.empleado.telefonoc) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.telefonoc]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_40,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.defTelefono('telefonoFlt'))),
                    id: "telefonoFlt",
                    type: "String",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.empleado.telefonoFlt) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.telefonoFlt]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_41,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.fixString('contEmerg'))),
                    id: "contEmerg",
                    type: "String",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.empleado.contEmerg) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.contEmerg]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_42,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.fixString('parentesco'))),
                    id: "parentesco",
                    type: "String",
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.empleado.parentesco) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.parentesco]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_43,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.defTelefono('telConyuge'))),
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.empleado.telConyuge) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.telConyuge]
                  ])
                ])
              ]),
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", null, [
                  _hoisted_46,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.fixString('direccion'))),
                    id: "direccion",
                    type: "String",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.empleado.direccion) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.direccion]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", null, [
                    _hoisted_48,
                    _withDirectives(_createElementVNode("input", {
                      id: "nombreRazonSocial",
                      type: "String",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.empleado.municipio) = $event)),
                      class: "form-control form-control-sm",
                      onFocus: _cache[33] || (_cache[33] = ($event: any) => (this.showModalMunicipioMethod()))
                    }, null, 544), [
                      [_vModelText, _ctx.empleado.municipio]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_49,
                    _withDirectives(_createElementVNode("input", {
                      disabled: "",
                      id: "nombreRazonSocial",
                      type: "String",
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.empleado.provincia) = $event)),
                      class: "form-control form-control-sm"
                    }, null, 512), [
                      [_vModelText, _ctx.empleado.provincia]
                    ])
                  ])
                ])
              ]),
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", null, [
                  _hoisted_52,
                  _withDirectives(_createElementVNode("select", {
                    id: "tiporh",
                    type: "String",
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.empleado.tiporh) = $event)),
                    class: "form-select form-select-sm"
                  }, _hoisted_61, 512), [
                    [_vModelSelect, _ctx.empleado.tiporh]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_62,
                  _withDirectives(_createElementVNode("input", {
                    id: "alergias",
                    type: "String",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.empleado.alergias) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.alergias]
                  ])
                ])
              ]),
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", null, [
                  _hoisted_65,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.fixString('nacionalidad'))),
                    id: "nacionalidad",
                    type: "String",
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.empleado.nacionalidad) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.nacionalidad]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_66,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.fixString('nivelacad'))),
                    id: "nivelacad",
                    type: "String",
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.empleado.nivelacad) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.nivelacad]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_67,
                  _withDirectives(_createElementVNode("select", {
                    id: "statcivil",
                    type: "String",
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.empleado.statcivil) = $event)),
                    class: "form-select form-select-sm"
                  }, _hoisted_71, 512), [
                    [_vModelSelect, _ctx.empleado.statcivil]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_72,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.fixString('conyuge'))),
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.empleado.conyuge) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.conyuge]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_73,
                  _withDirectives(_createElementVNode("input", {
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.empleado.ceduConyuge) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.ceduConyuge]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_74,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.defTelefono('telConyuge'))),
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.empleado.telConyuge) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.empleado.telConyuge]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_75,
                  _withDirectives(_createElementVNode("input", {
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.empleado.hijos) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.hijos]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_76,
                  _withDirectives(_createElementVNode("select", {
                    id: "aseguradora",
                    type: "String",
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.empleado.aseguradora) = $event)),
                    class: "form-select form-select-sm"
                  }, _hoisted_95, 512), [
                    [_vModelSelect, _ctx.empleado.aseguradora]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_96,
                  _withDirectives(_createElementVNode("input", {
                    id: "numerod",
                    type: "String",
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.empleado.numerod) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.numerod]
                  ])
                ])
              ]),
              _hoisted_97,
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", null, [
                  _hoisted_99,
                  _withDirectives(_createElementVNode("input", {
                    id: "fechaContrato",
                    type: "date",
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.empleado.fechaContrato) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.fechaContrato]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_100,
                  _withDirectives(_createElementVNode("input", {
                    id: "departamento",
                    type: "String",
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.empleado.departamento) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.departamento]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_101,
                  _withDirectives(_createElementVNode("input", {
                    id: "puesto",
                    type: "String",
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.empleado.puesto) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.puesto]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_102,
                  _withDirectives(_createElementVNode("input", {
                    id: "turno",
                    type: "String",
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.empleado.turno) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.turno]
                  ])
                ])
              ]),
              _hoisted_103,
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("div", null, [
                  _hoisted_105,
                  _withDirectives(_createElementVNode("input", {
                    id: "entidad",
                    type: "String",
                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.empleado.entidad) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.entidad]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_106,
                  _withDirectives(_createElementVNode("input", {
                    id: "cbank",
                    type: "String",
                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.empleado.cbank) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleado.cbank]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_107,
                  _withDirectives(_createElementVNode("select", {
                    id: "frecPag",
                    type: "String",
                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.empleado.frecPag) = $event)),
                    class: "form-select form-select-sm"
                  }, _hoisted_110, 512), [
                    [_vModelSelect, _ctx.empleado.frecPag]
                  ])
                ])
              ])
            ]),
            _hoisted_111,
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[57] || (_cache[57] = _withModifiers(($event: any) => (_ctx.createEmpleado()), ["prevent"]))
            }, _hoisted_114),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-danger",
                  onClick: _cache[58] || (_cache[58] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_117))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}